import React, { useRef, useState, useEffect } from "react";
import AboutHeroCard from "./AboutUs/AboutHeroCard";
import AboutContentCard from "./AboutUs/AboutContentCard";
import AboutVisionMission from "./AboutUs/AboutVisionMission";
import AboutUsCTA from "./AboutUs/AboutUsCTA";
import {FadeIn} from "../utils/AboutUsFadeEffects";
import AboutSEO from "./../seo/AboutSEO";
import { Helmet } from "react-helmet-async";

import '../css/AboutUs.css';

export default function About(){

return (
    <main className="w-full min-h-screen bg-white/45">

      <Helmet>
              <title>Madeshwara Ambulance Services | 24/7 Ambulance Services in Bangalore and Karnataka</title>
      </Helmet>

      <AboutSEO />

      {/* Hero: Logo + Title (bottom fade!) */}
      <section>
        <AboutHeroCard />
      </section>

      {/* "About Us" title (upwards fade—bottom) */}
      <section>
        <AboutContentCard />
      </section>


      {/* Slogan: Left fade */}
      <section className="py-6 px-4 pt-16 sm:px-8 max-w-3xl mx-auto text-center">
        <FadeIn direction="left">
          <h2 className="text-2xl font-bold text-sky-700 mb-3">
            Delivering Confidence in Every Emergency
          </h2>
          <span className="block mx-auto w-20 border-b-4 border-sky-300 mb-4"></span>
          <p className="text-gray-600 text-lg">
            Rapid arrival. Expert care. Peace of mind when it matters most.
          </p>
        </FadeIn>
      </section>
      
      {/* Vision/Mission (alternating fades) */}
      <section>
        <AboutVisionMission />
      </section>

      {/* Commitment/CTA: left fade */}
      <section className="pt-10">
        <AboutUsCTA />
      </section>


    </main>
  );
}
